"use client";

import { c as _c } from "react/compiler-runtime";
import TopOfferBanner from "./top-offer-banner";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { Sheet, SheetClose, SheetContent, SheetFooter, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import Logo from "./logo";
import Link from "next/link";
import { Container } from "./container";
import { Suspense, useState } from "react";
import dynamic from "next/dynamic";
const CountryCommand = dynamic(() => import("./country-command").then(mod => mod.CountryCommand), {
  ssr: false
});
import { ThemeSwitcher } from "./theme-switcher";
import CommandPaletteBlock from "./command-palette-block";
import { ListItem } from "./common/list-item";
const MegaMenu = dynamic(() => import("./common/mega-menu").then(mod => mod.MegaMenu));
import { Menu, MenuIcon, Headphones } from "lucide-react";
import { Spinner } from "./ui/spinner";
import Image from "next/image";
import { useCountry } from "@/hooks/use-country";
import { useRouteChange } from "@/hooks/use-route-change";
import { Dialog, DialogContent } from "./ui/dialog";
const TalkToLearningAdvisorForm = dynamic(() => import("./forms/talk-to-learning-advisor-form").then(mod => mod.TalkToLearningAdvisorForm), {
  ssr: false
});
const navLinks = [{
  label: "View Courses",
  href: "/courses"
}, {
  label: "Corporate",
  href: "/corporate-training"
}, {
  label: "Consulting",
  href: "/consulting"
}, {
  label: "One to one training",
  href: "/one-to-one-training"
}, {
  label: "About us",
  href: "/about-us"
}, {
  label: "Contact us",
  href: "/contact-us"
}, {
  label: "Blog",
  href: "/blog"
}];
export default function Header() {
  const $ = _c(52);
  const country = useCountry();
  const [open, setOpen] = useState(false);
  const [advisorOpen, setAdvisorOpen] = useState(false);
  const [navigationValue, setNavigationValue] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      onChangeComplete: () => {
        setOpen(false);
        setNavigationValue(null);
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useRouteChange(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TopOfferBanner />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `/${country ? country : ""}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Logo width={175} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <Link href={t2} className="flex shrink-0 items-center gap-2.5" title="Spoclearn">{t3}</Link>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NavigationMenuTrigger className="bg-primary/5" render={<Button variant="outline" />}><MenuIcon /> View Courses</NavigationMenuTrigger>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <NavigationMenuItem className="hidden md:flex">{t5}<NavigationMenuContent className="p-0" keepMounted={true}><Suspense fallback={<Spinner />}><MegaMenu /></Suspense></NavigationMenuContent></NavigationMenuItem>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <NavigationMenuList className="gap-4">{t6}<NavigationMenuItem><CommandPaletteBlock /></NavigationMenuItem></NavigationMenuList>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== navigationValue) {
    t8 = <NavigationMenu className="ml-6 hidden md:flex" align="start" value={navigationValue} onValueChange={setNavigationValue}>{t7}</NavigationMenu>;
    $[8] = navigationValue;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <NavigationMenuItem><NavigationMenuLink className={navigationMenuTriggerStyle()} render={<Link href="/corporate-training">Corporate</Link>} /></NavigationMenuItem>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <NavigationMenuItem><NavigationMenuLink className={navigationMenuTriggerStyle()} render={<Link href="/consulting">Consulting</Link>} /></NavigationMenuItem>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <NavigationMenuTrigger>Resource</NavigationMenuTrigger>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <NavigationMenu className="ml-auto hidden md:flex" align="end"><NavigationMenuList className="gap-2">{t9}{t10}<NavigationMenuItem>{t11}<NavigationMenuContent className="p-4" keepMounted={true}><ul className="w-96"><ListItem href="/blog" title="Blog" prefetch={false}>Latest insights and trends in education</ListItem><ListItem href="/news" title="News">Stay updated with industry news and announcements</ListItem></ul></NavigationMenuContent></NavigationMenuItem></NavigationMenuList></NavigationMenu>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setOpen(true);
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span aria-hidden="true" className="sr-only">country</span>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== country) {
    t15 = country?.toUpperCase() ?? "US";
    $[16] = country;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  const t16 = `https://purecatamphetamine.github.io/country-flag-icons/3x2/${t15}.svg`;
  const t17 = country ?? "US";
  const t18 = country ?? "US";
  let t19;
  if ($[18] !== t16 || $[19] !== t17 || $[20] !== t18) {
    t19 = <Button onClick={t13} variant="outline" size="icon" className="group relative overflow-visible">{t14}<Image src={t16} alt={t17} title={t18} width={20} height={14} className="relative z-10 h-3.5 w-5 rounded-xs object-cover transition-transform duration-200 group-hover:scale-110" /></Button>;
    $[18] = t16;
    $[19] = t17;
    $[20] = t18;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <ThemeSwitcher />;
    $[22] = t20;
  } else {
    t20 = $[22];
  }
  let t21;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = () => setAdvisorOpen(true);
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  let t22;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Button onClick={t21} variant="outline" size="icon" className="hidden sm:inline-flex lg:hidden" aria-label="Talk to training advisor"><Headphones className="size-4" /></Button>;
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  let t23;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = () => setAdvisorOpen(true);
    $[25] = t23;
  } else {
    t23 = $[25];
  }
  let t24;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Button onClick={t23} className="hidden items-center gap-2 lg:inline-flex"><Headphones className="size-4" />Talk to advisor</Button>;
    $[26] = t24;
  } else {
    t24 = $[26];
  }
  let t25;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Button variant="outline" size="icon" className="md:hidden" />;
    $[27] = t25;
  } else {
    t25 = $[27];
  }
  let t26;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <SheetTrigger render={t25} aria-label="Open menu"><Menu aria-hidden="true" /></SheetTrigger>;
    $[28] = t26;
  } else {
    t26 = $[28];
  }
  let t27;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <SheetHeader><SheetTitle className="flex items-center gap-2.5"><Logo width={175} /></SheetTitle></SheetHeader>;
    $[29] = t27;
  } else {
    t27 = $[29];
  }
  let t28;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <nav className="flex flex-col px-2">{navLinks.map(_temp)}</nav>;
    $[30] = t28;
  } else {
    t28 = $[30];
  }
  let t29;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Button onClick={() => setAdvisorOpen(true)} />;
    $[31] = t29;
  } else {
    t29 = $[31];
  }
  let t30;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <Sheet>{t26}<SheetContent side="left" className="w-full sm:max-w-xs">{t27}{t28}<SheetFooter><SheetClose render={t29} className="mt-4 w-full"><Headphones className="mr-2 inline size-4" />Talk to training advisor</SheetClose></SheetFooter></SheetContent></Sheet>;
    $[32] = t30;
  } else {
    t30 = $[32];
  }
  let t31;
  if ($[33] !== t19) {
    t31 = <div className="ml-auto flex shrink-0 items-center gap-2 md:ml-2">{t19}{t20}{t22}{t24}{t30}</div>;
    $[33] = t19;
    $[34] = t31;
  } else {
    t31 = $[34];
  }
  let t32;
  if ($[35] !== t31 || $[36] !== t4 || $[37] !== t8) {
    t32 = <Container className="relative flex h-16 w-full items-center">{t4}{t8}{t12}{t31}</Container>;
    $[35] = t31;
    $[36] = t4;
    $[37] = t8;
    $[38] = t32;
  } else {
    t32 = $[38];
  }
  let t33;
  if ($[39] !== open) {
    t33 = open && <Suspense><CountryCommand open={open} onOpenChange={setOpen} /></Suspense>;
    $[39] = open;
    $[40] = t33;
  } else {
    t33 = $[40];
  }
  let t34;
  if ($[41] !== advisorOpen) {
    t34 = advisorOpen && <TalkToLearningAdvisorForm heading="Talk to a Learning Advisor" subHeading="Submit this form to trigger an advisor callback to your phone." submitLabel="Initiate Call" onSuccess={() => setAdvisorOpen(false)} />;
    $[41] = advisorOpen;
    $[42] = t34;
  } else {
    t34 = $[42];
  }
  let t35;
  if ($[43] !== t34) {
    t35 = <DialogContent className="p-0 sm:max-w-md">{t34}</DialogContent>;
    $[43] = t34;
    $[44] = t35;
  } else {
    t35 = $[44];
  }
  let t36;
  if ($[45] !== advisorOpen || $[46] !== t35) {
    t36 = <Dialog open={advisorOpen} onOpenChange={setAdvisorOpen}>{t35}</Dialog>;
    $[45] = advisorOpen;
    $[46] = t35;
    $[47] = t36;
  } else {
    t36 = $[47];
  }
  let t37;
  if ($[48] !== t32 || $[49] !== t33 || $[50] !== t36) {
    t37 = <header className="border-border bg-background fixed top-0 right-0 left-0 z-50 border-b">{t1}{t32}{t33}{t36}</header>;
    $[48] = t32;
    $[49] = t33;
    $[50] = t36;
    $[51] = t37;
  } else {
    t37 = $[51];
  }
  return t37;
}
function _temp(link) {
  return <SheetClose key={link.label} render={<a href={link.href} />} nativeButton={false} className="text-muted-foreground hover:bg-muted hover:text-foreground px-2 py-2.5 text-sm font-medium transition-colors">{link.label}</SheetClose>;
}